(() => {
  const $  = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));
  const isMobile = () => window.matchMedia('(max-width: 900px)').matches;

  const waitFor = (fn, cb, timeout=10000, step=120) => {
    const t0 = Date.now();
    (function tick(){
      const val = fn();
      if (val) return cb(val);
      if (Date.now()-t0 > timeout) return;
      setTimeout(tick, step);
    })();
  };

  const findBar = () => $('.sticky-atc-button') || $('.sticky-atc-button__button');
  const findRecurpay = () => {
    const rpRoot = $('.recurpay-pdp-widget [data-recurpay-widget]');
    if (!rpRoot) return null;
    const sub = rpRoot.querySelector('.recurpay__widget_container[data-type="subscription-purchase"]');
    const one = rpRoot.querySelector('.recurpay__widget_container[data-type="onetime-purchase"]');
    if (!sub || !one) return null;
    return { rpRoot, sub, one };
  };

  waitFor(findBar, (bar) => {
    waitFor(findRecurpay, ({rpRoot, sub, one}) => enhance(bar, rpRoot, sub, one));
  });

  function enhance(bar, rpRoot, subCon, oneCon){
    if (bar.classList.contains('vp-enhanced')) return;

    const getText = (c, sel) => (c && c.querySelector(sel)) ? c.querySelector(sel).textContent.trim() : '';
    const priceSub = () => getText(subCon, '.recurpay__group_selling_price .money, .recurpay__group_selling_price');
    const priceOne = () => getText(oneCon, '.recurpay__group_selling_price .money, .recurpay__group_selling_price');
    const priceOrig = () => getText(subCon, '.recurpay__group_compare_price .money, .recurpay__group_compare_price');

    bar.classList.add('vp-enhanced');
    bar.setAttribute('data-visible','true');

    var subP = priceSub() || '$28.72';
    var oneP = priceOne() || '$35.90';
    var origP = priceOrig() || '$35.90';
    var prodName = (document.title||'').split(/[–—|]/)[0].replace(/\s+/g,' ').trim() || 'Vital Pour';

    bar.insertAdjacentHTML('beforeend',
      '<div class="vp-sticky__inner" id="vpStickyInner">' +
        '<div class="vp-sticky__product">' +
          '<div class="vp-sticky__product-img">' +
            '<span class="vp-sticky__logo">VP</span>' +
          '</div>' +
          '<div class="vp-sticky__product-info">' +
            '<span class="vp-sticky__product-name">' + prodName + '</span>' +
            '<span class="vp-sticky__product-rating">' +
              '<span class="vp-sticky__stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
              ' 4.8 &middot; 194 reviews' +
            '</span>' +
          '</div>' +
        '</div>' +
        '<div class="vp-sticky__price-col">' +
          '<span class="vp-sticky__price-main" id="vpStickyOnePrice">' + oneP + '</span>' +
          '<span class="vp-sticky__price-sub">One-time purchase</span>' +
        '</div>' +
        '<button type="button" class="vp-sticky__btn vp-sticky__btn--one" id="vpStickyOne">' +
          '<span class="vp-sticky__label">Buy Once <span class="vp-sticky__btn-price" id="vpStickyOneBtnPrice">' + oneP + '</span></span>' +
        '</button>' +
        '<div class="vp-sticky__sub-group">' +
          '<div class="vp-sticky__sub-price">' +
            '<span class="vp-sticky__sub-price-current" id="vpStickySubPrice">' + subP + '</span>' +
            '<span class="vp-sticky__sub-price-original" id="vpStickyOrigPrice">' + origP + '</span>' +
          '</div>' +
          '<button type="button" class="vp-sticky__btn vp-sticky__btn--sub" id="vpStickySub">' +
            '<span class="vp-sticky__label">Subscribe & Save <span class="vp-sticky__btn-price" id="vpStickySubBtnPrice">' + subP + '</span></span>' +
          '</button>' +
        '</div>' +
      '</div>'
    );

    $('#vpStickySub').addEventListener('click', () => {
      subCon.querySelector('.recurpay__group_input')?.click();
      rpRoot.querySelector('[data-recurpay-action]')?.click();
    });
    $('#vpStickyOne').addEventListener('click', () => {
      oneCon.querySelector('.recurpay__group_input')?.click();
      var main = $('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"], .product-form__submit');
      main?.click();
    });

    var syncPrices = () => {
      var sub = priceSub(), one = priceOne(), orig = priceOrig();
      var ps = $('#vpStickySubPrice'); if (ps && sub) ps.textContent = sub;
      var po = $('#vpStickyOnePrice'); if (po && one) po.textContent = one;
      var pp = $('#vpStickyOrigPrice'); if (pp && orig) pp.textContent = orig;
      var pbOne = $('#vpStickyOneBtnPrice'); if (pbOne && one) pbOne.textContent = one;
      var pbSub = $('#vpStickySubBtnPrice'); if (pbSub && sub) pbSub.textContent = sub;
    };
    new MutationObserver(syncPrices).observe(rpRoot, {subtree:true, childList:true, characterData:true, attributes:true});
    syncPrices();

    function lockMobileVisible(){
      if (!isMobile()) return;
      bar.setAttribute('data-visible','true');
      document.body.classList.add('vp-sticky-padding');
      new MutationObserver(function(){
        if (bar.getAttribute('data-visible') !== 'true') bar.setAttribute('data-visible','true');
      }).observe(bar, { attributes:true, attributeFilter:['data-visible']});
    }
    lockMobileVisible();
    window.addEventListener('resize', lockMobileVisible);

    var mainATC = $('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"], .product-form__submit');
    var rpBtn   = rpRoot.querySelector('[data-recurpay-action]');
    var flags   = { main:true, rp:true };

    var io = new IntersectionObserver(function(entries){
      if (isMobile()) return;
      entries.forEach(function(e){
        var key = (e.target === mainATC) ? 'main' : 'rp';
        flags[key] = !e.isIntersecting;
      });
      var show = flags.main && flags.rp;
      bar.setAttribute('data-visible', show ? 'true' : 'false');
      document.body.classList.toggle('vp-sticky-padding', show);
    }, { threshold:0.01 });

    if (mainATC) io.observe(mainATC);
    if (rpBtn)   io.observe(rpBtn);
  }
})();
